import React from 'react';
import {
    Row, Col, Button,
} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import Widget from '../../components/Widget';
import s from './PrincipalDashboard.module.scss';
import {SalesDetail} from "../../components/sales/SalesDetail";
import TimeFilter from './../../components/filter/TimeFilter'
import {MonthFilter} from './../../components/filter/MonthFilter'
import {SectionalFilter} from './../../components/filter/SectionalFIlter'
import PubSub from "pubsub-js";
import LoadingModal from "../../components/filter/LoadingModal";


class PrincipalDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            maxYear: 2023,
            mes : 2,
            sectional : 'ARMENIA',
            showModal: false
        };
        this.onChangehandle = this.onChangehandle.bind(this);
        this.onChangehandlemonth = this.onChangehandlemonth.bind(this);
        this.onChangehandlesectional = this.onChangehandlesectional.bind(this);
    }
    onChangehandle(e){
        console.log(e.target.value)
        this.setState({
            maxYear: e.target.value
        }, () => {
            PubSub.publish('reloadmaxYear', 'Reloading maxYear');
        })
    }

    onChangehandlemonth(e){
        console.log(e.target.value)
        this.setState({
            mes: e.target.value
        }, () => {
            PubSub.publish('reloadmes', 'Reloading mes');
        })
    }

    onChangehandlesectional(e){
        console.log(e.target.value)
        this.setState({
            sectional: e.target.value
        }, () => {
            PubSub.publish('reloadsectional', 'Reloading sectional');
        })
    }

    onLoading = (showModal) => {
        this.setState({
            showModal: showModal
        })
    }

    render() {
        return (
            <div className={s.root}>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">Estas en</li>
                    <li className="breadcrumb-item active">Detalle Ventas</li>
                </ol>
                <h1 className="page-title"><span className="fw-semi-bold">Detalle Ventas</span></h1>
                <LoadingModal show={this.state.showModal}/>
                <Widget title={<h6> General </h6>} close collapse settings>

                    <Row>
                        <Col xs={12} md ={4}>
                            <Widget>
                                <TimeFilter
                                    handleChange={this.onChangehandle}
                                    onLoading={this.onLoading}
                                />
                            </Widget>
                        </Col>
                        <Col xs={12} md ={4}>
                            <Widget>
                                <MonthFilter
                                    handleChangemonth={this.onChangehandlemonth}
                                    onLoading={this.onLoading}
                                />
                            </Widget>
                        </Col>
                        <Col xs={12} md ={4}>
                            <Widget>
                                <SectionalFilter
                                    handleChangesectional={this.onChangehandlesectional}
                                    onLoading={this.onLoading}
                                />
                            </Widget>
                        </Col>
                        <Col lg="12" xs="100%">
                            <div className="location-selector">
                                <SalesDetail maxYear={this.state.maxYear}
                                             mes = {this.state.mes}
                                             sectional = {this.state.sectional}
                                             onLoading={this.onLoading} />
                            </div>
                        </Col>
                    </Row>
                </Widget>
            </div>
        );
    }
}

// function mapStateToProps(state) {
//     return {
//         isFetching: state.filtroTiempo.isFetching,
//         filtroTiempo: state.filtroTiempo.filtroTiempo,
//     };
// }
//export default connect(mapStateToProps)(PrincipalDashboard);
export default PrincipalDashboard;
